import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, ArrowRight } from 'lucide-react';
export function AboutHiring() {
  return <section className="py-20 bg-ink relative overflow-hidden" data-id="element-463">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-464" />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-465">
        <div className="inline-flex items-center justify-center w-14 h-14 bg-storm-red/15 text-storm-red rounded-2xl mb-6" data-id="element-466">
          <Briefcase className="w-7 h-7" data-id="element-467" />
        </div>
        <h2 className="text-4xl md:text-5xl text-white mb-4" data-id="element-468">We're Hiring!</h2>
        <p className="text-lg text-gray-warm mb-8 max-w-xl mx-auto" data-id="element-469">
          Join our team and make a difference in the lives of our students.
        </p>
        <Link to="/ContactUs.html" className="btn-primary inline-flex items-center gap-2" data-id="element-470">
          View Open Positions
          <ArrowRight className="w-5 h-5" data-id="element-471" />
        </Link>
      </div>
    </section>;
}